/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-25T10:37:42.929
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listRentHouseTypeSales,
	listRentHouseTypeSalesInit,
	listRentHouseTypeSalesByAuthorizations,
	deleteRentHouseTypeSales
	
} from '@api/rentmanage/RentHouseTypeSales';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listRentHouseTypeSales({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTypeSales(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseTypeSalesByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTypeSalesByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listRentHouseTypeSalesInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listRentHouseTypeSalesInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentHouseTypeSales({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentHouseTypeSales({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
